import { Suspense } from "react";
import { useParams, Outlet } from "react-router-dom";
import { API, graphqlOperation } from "aws-amplify";
import { getProductLibBanner } from "../../graphql/queries";
import wrapPromise from "../../helpers/wrapPromise";
import BannerContext from "../../contexts/BannerContext";
import Waiting from "../../components/Waiting";
import { extractBanner } from "../../helpers/extract";

function Banner() {
  const params = useParams();
  const bannerId = params.bannerId ? params.bannerId : "";

  const fetchBannerData = () => {
    const banner: any = API.graphql(
      graphqlOperation(getProductLibBanner, { id: bannerId })
    );

    return {
      banner: wrapPromise(banner),
    };
  };

  const bn = fetchBannerData();

  const ShowBanner = ({ bn }: any) => {
    const banner = bn.banner.read();
    const bannerInfo = extractBanner(banner);
    if (!bannerInfo) {
      return <></>; //go to un auth page.
    }

    return (
      <>
        <BannerContext.Provider
          value={{
            banner: bannerInfo,
          }}
        >
          <Outlet />
        </BannerContext.Provider>
      </>
    );
  };

  return (
    <Suspense fallback={<Waiting />}>
      <ShowBanner bn={bn} />
    </Suspense>
  );
}
export default Banner;
